var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 20,
  viewBox: "0 0 16 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#528AEA",
  fillRule: "evenodd",
  d: "M1.876 17.814c0 1.161.95 2.111 2.11 2.111h8.445c1.161 0 2.111-.95 2.111-2.11V5.147H1.876v12.666zM15.598 1.981h-3.695L10.848.925H5.57L4.515 1.981H.82v2.111h14.778V1.981z",
  opacity: .9
})));
export default __webpack_public_path__ + "teg/media/trash.af47336b.svg";
export { SvgComponent as ReactComponent };